import React from 'react'
import { connect } from 'react-redux'
import { setCheat } from '../../redux/actions'

const inputStyle = { width: '25px', height: '25px', cursor: 'pointer' }

const IsJsonString = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

/**
 * The cheats sub-category in the DevTools.
 * This will create a list of forced outcomes that can be toggled,
 * so that any round played will use the chosen forced outcome.
 */
@connect(state => ({
  response: state.base.response,
  serverCheat: state.base.serverCheat,
  gameCheats: state.base.gameCheats,
}), {
  setCheat,
})
export default class CheatPage extends React.Component {
  state = { open: true }

  setCustomCheat = () => {
    if (!this.cheatToggle.checked) {
      this.props.setCheat(null)
      return
    }

    const cheat = this.cheatBox.value

    if (IsJsonString(cheat)) {
      this.props.setCheat(cheat)
    } else {
      this.props.setCheat(null)
      setTimeout(() => {
        alert('Cheat is not a valid JSON!')
      })
    }
  }

  setCheat = (cheat) => {
    return () => {
      this.props.setCheat(cheat)
    }
  }

  render() {
    const { open = false } = this.state
    const { serverCheat, gameCheats = {} } = this.props
    let isServerCheat = false
    Object.keys(gameCheats).forEach(key => {
      if (gameCheats[key] === serverCheat) {
        isServerCheat = true
      }
    })

    return (
      <div className="devConsolePage">
        <div className="devSelector">
          <input type="radio" checked={!isServerCheat} onClick={this.setCustomCheat} style={inputStyle}
            ref={e => { this.cheatToggle = e }} id="custom" />

          <label style={{ marginLeft: 10, verticalAlign: 7, cursor: 'pointer' }} htmlFor="custom">
            Custom Cheat:
          </label>

          <input type="text" ref={e => { this.cheatBox = e }} onBlur={this.setCustomCheat}
            defaultValue={isServerCheat ? '{}' : serverCheat} />
        </div>
        { Object.keys(gameCheats).map(cheatName => (
          <div className="devSelector" key={`cheat${cheatName}`}>
            <input type="radio" checked={serverCheat === gameCheats[cheatName]}
              onChange={this.setCheat(gameCheats[cheatName])} style={inputStyle}
              id={`server${cheatName}`} />

            <label style={{ marginLeft: 10, verticalAlign: 7, cursor: 'pointer' }}
              htmlFor={`server${cheatName}`}>
              { cheatName }:
            </label>

            <span className="comment" style={{ marginLeft: 10, verticalAlign: 7 }}>
              { gameCheats[cheatName] }
            </span>
          </div>
        )) }
      </div>
    )
  }
}
